const Theme = {
  body_background_color: '#efede0',
  card_background_color: 'white',
  logo_height: 140,
  logo_image_url:'esa.svg',
  number_hidden:true,
  token_hidden:true,

  header_background_color: '#efede0',

  button_radius: 25,
  button_border_width:2,
  button_color: '#56A7DC',
  button_text_color: 'white',
  button_hover_border_color: '#56A7DC',

  button_outlined_text_color: 'black',
  button_outlined_border_color: '#56A7DC',

  text_font: 'Metropolis',
  text_color: 'black',

  title_font: 'Metropolis',
  title_weight: 400,
  subtitle_font: 'Metropolis',
}

export default Theme
